module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/uk-card-drag.b05743da18ce0a1cafe1.gif";